module.exports = __webpack_public_path__ + "img/WechatIMG30252.ff34163d.jpg";